import React, { useEffect } from "react";
import Card from "./Card";
import "../styles/exploreTeam.css";
import firebase from "../firebase";
import { motion, useViewportScroll } from "framer-motion";
import { useState } from "react";

const DSCLead = () => {
  const [x, setX] = useState(0);
  const factor = 1 / 4;
  const [dscLead, setDscLead] = useState({});
  const [loading, setLoading] = useState(false);
  const refMembers = firebase.firestore().collection("members");
  function getDscLead() {
    setLoading(!loading);
    refMembers
      .where("role", "==", "Lead")
      .where("active", "==", true)
      .get()
      .then((querySnapshot) => {
        const items = [];
        querySnapshot.forEach((doc) => items.push(doc.data()));
        setDscLead(items[0]);
      });
    setLoading(!loading);
  }
  useEffect(() => {
    getDscLead();
  }, []);
  const { scrollYProgress } = useViewportScroll();
  scrollYProgress.onChange((value) => {
    setX(value);
    // console.log(x);
  });
  return (
    <motion.div
      initial={{
        opacity: 0,
        x: 1200,
      }}
      animate={{
        x: x >= (0.6 * factor) / 2 ? 0 : 0,
        opacity: 1,
      }}
      transition={{ stiffness: 60, duration: 0.6, type: "spring" }}
      className="
      mt-10
        h-screen
        flex
        flex-col
        justify-around
        md:justify-center
        items-center
        relative
      "
    >
      <h1
        className="headline
          mb-4
          md:mb-28
          text-5xl
          relative
          dark:text-white
          text-center
        "
      >
        Meet Our DSC Lead
      </h1>
      {dscLead && (
        <div className="lead-card">
          <Card
            name={dscLead.name}
            image={dscLead.profileImage}
            skill={dscLead.description}
            position={dscLead.role}
            classStudying={dscLead.department}
            year={dscLead.year}
            linkedin={dscLead.linkedin ? dscLead.linkedin : ""}
            github={dscLead.github ? dscLead.github : ""}
            facebook={dscLead.facebook ? dscLead.facebook : ""}
            instagram={dscLead.instagram ? dscLead.instagram : ""}
          />
        </div>
      )}
    </motion.div>
  );
};

export default DSCLead;
